/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/247-confused2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a8 8 0 100 16A8 8 0 008 0zm3 4a1 1 0 110 2 1 1 0 010-2zM5 4a1 1 0 110 2 1 1 0 010-2zm5.735 8.665a2.502 2.502 0 01-3.204-1.494 1.502 1.502 0 00-1.923-.896A1.502 1.502 0 004.655 12H3.642a2.505 2.505 0 011.624-2.665 2.502 2.502 0 013.204 1.494 1.502 1.502 0 001.923.896A1.502 1.502 0 0011.346 10h1.014a2.505 2.505 0 01-1.624 2.665z"/>'
  }
})
